export enum QuestInfoType {
    None = 0,
    Profession = 1,
    Normal = 2,
    Pvp = 3,
    PetBattle = 4,
    Bounty = 5,
    Dungeon = 6,
    Invasion = 7,
    Raid = 8,
    Contribution = 9,
    RatedPvp = 10,
    InvasionWrapper = 11,
    FactionAssault = 12,
    IslandWeekly = 13,
    Threat = 14,
    CovenantCalling = 15,
    DragonRacing = 16,
    Capstone = 17,
    WorldBoss = 18,
}
